<!-- layouts/default.vue -->
<script setup>
import { useAppStore } from '~/store/main'

const Warning = defineAsyncComponent(() => import('~/components/Warning.vue'))

const store = useAppStore()
const { isLoaderActive, root, theme, headerHeight } = storeToRefs(store)
const { setScreenWidth, setTheme, setIsLoaderActive } = store

const oldScrollY = ref(0)
const scrollDown = ref(false)
const scrollFinished = ref(true)
const scrollTimer = ref(-1)

const colorMode = useColorMode()

const themeCookie = useCookie('theme', { maxAge: 0.5 * 24 * 60 * 60 }) // 0.5 дня

const rootTheme = computed(() => [root.value, theme.value])

watch(rootTheme, ([newRoot, newTheme]) => {
  if (newTheme === 'light') {
    colorMode.preference =
      newRoot === 'studium'
        ? 'light-red'
        : newRoot === 'akademie'
          ? 'light-green'
          : 'light-blue'
  } else {
    colorMode.preference =
      newRoot === 'studium'
        ? 'dark-red'
        : newRoot === 'akademie'
          ? 'dark-green'
          : 'dark-blue'
  }
})

const handleResize = () => {
  setScreenWidth(window.innerWidth)
}

const onScroll = () => {
  clearTimeout(scrollTimer.value)
  scrollTimer.value = setTimeout(() => {
    scrollFinished.value = true
  }, 100)
  scrollFinished.value = false
  scrollDown.value = oldScrollY.value < window.scrollY + 2
  oldScrollY.value = window.scrollY
}

onBeforeMount(() => {
  setScreenWidth(window.innerWidth)
})

onMounted(() => {
  window.addEventListener('resize', handleResize)

  window.addEventListener('scroll', onScroll)

  if (!themeCookie.value) {
    const isDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches
    const initialTheme = isDarkMode ? 'dark' : 'light'
    setTheme(initialTheme)
    themeCookie.value = initialTheme
  } else {
    setTheme(themeCookie.value)
  }
})

onUnmounted(() => {
  window.removeEventListener('resize', handleResize)
  window.removeEventListener('scroll', onScroll)
})

onMounted(() => {
  setTimeout(() => {
    setIsLoaderActive(false)
  }, 500)
})
</script>

<template>
  <div>
    <div class="wrapper" :class="{ loading: isLoaderActive }">
      <div>
        <Header />
        <div class="content__warning">
          <ClientOnly>
            <Warning />
          </ClientOnly>
        </div>
        <div
          class="content"
          :class="{ 'content--opacity': !scrollDown && !scrollFinished }"
          :style="{ paddingTop: `${headerHeight}px` }"
        >
          <main>
            <slot />
          </main>
          <Footer />
        </div>
      </div>
      <WebLoader v-if="isLoaderActive" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
.content__warning {
  padding: 0 20px;
}
</style>
